module.exports = __webpack_public_path__ + "img/home_pic_3.0_1.b9ff9941.webp";